import type { CDescriptivePageTranslations } from "./pl";

export const en: CDescriptivePageTranslations = {
  emptyData: "No data to display.",
  emptyContent: "This page has no content yet.",
};
